import { TemplateRef, Type } from '@angular/core';
import { PopoverPositionEnum } from '../../../../../core/enums/utils';

export type PopoverContent = TemplateRef<any> | Type<any> | string | null;

export class PopoverData<T> {
  // @ts-ignore
  origin: HTMLElement;
  // @ts-ignore
  content: PopoverContent;
  // @ts-ignore
  preferredPosition: PopoverPositionEnum;
  data?: T;
}

export interface PopoverConfig {
  animationFadeIn?: number;
  animationFadeOut?: number;
}

export const configData: PopoverConfig = {
  animationFadeIn: 200,
};
